
        function Loading({ label = 'Loading' }) {
            return (
                <div className="py-16 text-center">
                    <div className="font-mono text-xs uppercase tracking-widest text-muted mb-4">{label}</div>
                    <div className="pulse-line max-w-md mx-auto"></div>
                </div>
            );
        }

export { Loading };
